/*
 * @Author: 南岸有归
 * @Date: 2020-02-24 09:24:27
 * @LastEditTime: 2020-04-15 17:52:58
 * @LastEditors: 南岸有归
 * @Description: 
 * @FilePath: \cloud_frontend\src\api\firmware.js
 * @
 */
import http from '@/axios/http'
import { getuser_id } from "@/localStorage/localStorage";

//获取批量配置任务列表
export function listConfig(offset, limit ,state ,tid) {
    const data = {
        user_id: getuser_id(),
        offset,
        limit,
        state,
        tid
    }
    tid==undefined?delete data.tid:tid
    return http({
        url: '/api/configTask/listConfig',
        method: 'post',
        data
    })
}
//获取固件列表
export function listConfigurationFile() {
    const data = {
        user_id: getuser_id(),
        offset: 1,
        limit: 99999
    }
    return http({
        url: '/api/configurationFileManager/listConfigurationFile',
        method: 'post',
        data
    })
}
//删除固件任务
export function delLevelUp(id) {
    const data = {
        id: id
    }
    return http({
        url: '/api/configTask/delConfigTask',
        method: 'post',
        data
    })
}

//删除固件子任务
export function delSonLevelUp(id) {
    console.log(id)
    const data = {
        id: id
    }
    return http({
        url: '/api/configTask/delSonConfigTask',
        method: 'post',
        data
    })
}

//查询与排序
export function queryKeyword(keyword, offset, limit, sort,state,tid) {
    const data = {
        user_id: getuser_id(),
        keyword: keyword,
        offset: offset,
        limit: limit,
        tname: sort.tName, //任务名
        tdescription: sort.tDescription, //任务描述
        progress: sort.stProgress, //完成进度
        cfName: sort.cfName, //文件名
        updatetime: sort.tUpdate, //更新时间
        state,
        tid
    }
    tid==undefined?delete data.tid:tid
    return http({
        url: '/api/configTask/queryKeyword',
        method: 'post',
        data
    })
}

//获取获取子任务
export function GetListConfig(parentTid) {
    return http({
        url: '/api/configTask/sub/listConfig',
        method: 'post',
        data:{parentTid}
    })
}
